@if (showSpinner) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <table #matTableRef mat-table [dataSource]="dataSource" [trackBy]="trackBy" [multiTemplateDataRows]="expandable" class="mat-elevation-z8" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (column of table?.columns; track column) {
      <ng-container [matColumnDef]="column.field">
        <th class="text-primary-darker" mat-header-cell *matHeaderCellDef>
          @if (!column.hideColumnLabel) {
            {{ column.label | translateWithKeys }}
          }
          @if (column.headerTemplate) {
            <ng-container [ngTemplateOutlet]="headerTemplate">
            </ng-container>
          }

        </th>
        <td mat-cell *matCellDef="let element; let i = index;"
        [ngClass]="{ 'actions': table?.actions }"
        [matTooltip]="element[column.field]"
        [matTooltipDisabled]="
          !(column.showTooltip) ||
          (element[column.field]?.length < (column.showTooltipAfter ?? 40))
        "
        [ngStyle]="{ 'text-align': column.field === 'actions' ? 'end' : 'unset' }">

          @if (column.field !== 'actions') {
            @if (column.field === 'selectable') {
              <ng-container *ngIf="column.template !== undefined && column.template !== null"
              [ngTemplateOutlet]="column.template"
              [ngTemplateOutletContext]="{ element, i, disableColumnCondition: column?.disableColumnCondition }">
            </ng-container>
          }
          <ng-container>
            @if (column.template && column.field !== 'selectable') {
              <ng-container *ngTemplateOutlet="column.template; context: { element: element, index: i, isElementExpanded: expandedElement === element, disableColumnCondition: column?.disableColumnCondition }"></ng-container>
            }
            @if (!column.showOnlyTemplate) {
              {{ element[column.field] }}
            }
          </ng-container>
        } @else if (column.field === 'actions') {
          <ng-container [ngTemplateOutlet]="actions" [ngTemplateOutletContext]="{ element, i, disableColumnCondition: column?.disableColumnCondition }">
          </ng-container>
        }
        </td>
      </ng-container>
    }

	@if (expandable) {
		<ng-container matColumnDef="expand">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let element" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()"></td>
		</ng-container>

		<ng-container matColumnDef="expandedDetail">
			<td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
				<div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
					@if (expandableTemplate) {
						<ng-container [ngTemplateOutlet]="expandableTemplate" [ngTemplateOutletContext]="{ element }"></ng-container>
					}
				</div>
			</td>
		</ng-container>
	}

    <tr mat-header-row *matHeaderRowDef="expandable ? columnsToDisplayWithExpand : displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: expandable ? columnsToDisplayWithExpand : displayedColumns;" cdkDrag [cdkDragDisabled]="table?.type != 'draggable'"
      [ngClass]="{'grab': table?.type === 'draggable', 'pointer': table?.type === 'none' && table?.selectable}"
      (click)="onRowClick(row)"
      ></tr>
	@if (expandable) {
		<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
	}
  </table>
}

<ng-template #deleteBtn let-element="element" let-index="i">
  <button mat-icon-button (click)="selectedItemToDelete(element)">
    <mat-icon class="close" svgIcon="close"></mat-icon>
  </button>
</ng-template>

<ng-template #actions let-element="element" let-index="i">
	@if (actionColumnTemplate) {
		<ng-container [ngTemplateOutlet]="actionColumnTemplate" [ngTemplateOutletContext]="{ element, index }"></ng-container>
	} @else {
		@if(isPlay){
			<button mat-icon-button *hasPermission="PermissionsEnum.EDIT_VIDEO" (click)="playVideo(element)"> <mat-icon svgIcon="edit"></mat-icon> </button>
		}
		@if(isEdit){
			<button mat-icon-button *hasPermission="[PermissionsEnum.EDIT_COURSE, PermissionsEnum.EDIT_CATEGORY, PermissionsEnum.EDIT_CLIENT, PermissionsEnum.EDIT_STUDENT]; inclusive: false" (click)="openEditModal(element)"> <mat-icon svgIcon="edit"></mat-icon> </button>
		}
		@if(isEditQuestion){
			<button mat-icon-button *hasPermission="PermissionsEnum.EDIT_COURSE" (click)="editQuestion(element, index)"> <mat-icon svgIcon="edit"></mat-icon> </button>
		}
		@if(isEditChapter){
			<button mat-icon-button *hasPermission="PermissionsEnum.EDIT_COURSE" (click)="editChapter(element)"> <mat-icon svgIcon="edit"></mat-icon> </button>
		}
		@if(isDownload){
			<button mat-icon-button> <mat-icon svgIcon="download"></mat-icon> </button>
		}
		@if(isDeleted){
			<button *ngIf="
        (element?.isDefault && element.isDefault === false)
        ||
        (element?.__assignedCategories?.length && element.__assignedCategories[0].status === PublishStatusEnum.DRAFT)
        ||
        isEditChapter
        "
        class="delete-btn"
        mat-icon-button
        (click)="selectedItemToDelete(element, index)">
        <mat-icon class="delete-icon" svgIcon="trash"></mat-icon>
			</button>
		}
	}
</ng-template>

<ng-template #checkbox let-element="element">
  <mat-checkbox [checked]="isSelected(element)" (change)="selectedItem($event, element)" class="mr-10"></mat-checkbox>
</ng-template>

<ng-template #toggle let-element="element" let-disableColumnCondition="disableColumnCondition">
	<mat-slide-toggle [(ngModel)]="element.active" (change)="toggleChange($event.checked, element)" [disabled]="disableColumnCondition ? disableColumnCondition(element) : disabledToggle(element)" [matTooltip]="toggleTooltipText | translateWithKeys" [matTooltipDisabled]="!toggleTooltipText || element.__isFullTranslated"></mat-slide-toggle>
</ng-template>


<ng-template #draggable let-element="element" let-index="index">
  <mat-icon class="draggable" svgIcon="draggable"></mat-icon>
  {{index + 1}}
</ng-template>

<ng-template #headerTemplate let-element="element" let-index="index">
	@if(tooltipText?.length > 0){
 		<button class="tooltip" mat-icon-button [matTooltip]="tooltipText" aria-label="Button that displays a tooltip when focused or hovered over">
			<mat-icon class="tooltip-icon" svgIcon="tooltip_icon"></mat-icon>
		</button>
	}
</ng-template>
